const ParameterEmptyObject = {

};

export {
	ParameterEmptyObject
};